import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main";
import About from "../pages/About/About";
import Home from "../pages/Home/Home";
import Detail from "../pages/Project/Detail";
import Project from "../pages/Project/Project";
import Contact from './../pages/Contact/Contact';



const router = createBrowserRouter([
    {
        path:"/",
        element:<Main></Main> ,
        children:[
           {
            path:"/",
            element:<Home></Home>
           },
           {
            path:"/about",
            element:<About></About>
           },
           {
            path:"/contact",
            element:<Contact></Contact>
           },
           {
            path:"/project",
            element:<Project></Project>
           },

           {
            path:"/projects/:id",
            element:<Detail></Detail>,
            loader: ({ params }) =>
            fetch(
              `https://server-mu-six.vercel.app/projects/${params.id}`
            ),
           },
        ]
    }
])

export default router;